import { Link } from "@tanstack/react-router";
import { Icon } from "../lib/Icon";
import { usePortal } from "./state";
import { projectsForBrand } from "./projects";

const HEALTH: Record<string, { bg: string; fg: string }> = {
  ok: { bg: "#e8f4ee", fg: "#1f8a5b" },
  warn: { bg: "#fbf2dc", fg: "#9a6a12" },
  bad: { bg: "#fbe9e7", fg: "#b3261e" },
};

export function PortalProjects() {
  const { brand, brandId } = usePortal();
  const projects = projectsForBrand(brandId);

  return (
    <div style={{ maxWidth: 1000, margin: "0 auto", padding: "30px 28px 64px", display: "flex", flexDirection: "column", gap: 18 }}>
      <div>
        <h1 style={{ margin: 0, fontSize: 24, fontWeight: 600, letterSpacing: "-0.6px", color: "#1d241f" }}>Projects</h1>
        <p style={{ margin: "6px 0 0", fontSize: 13.5, color: "#8a8e88", textWrap: "pretty" }}>The projects you're a member of — burn-down against approved hours, your tasks, and a line to the team.</p>
      </div>

      {projects.length === 0 ? (
        <div style={{ border: "1px dashed #dcdad2", background: "#fafaf7", borderRadius: 3, padding: "40px 20px", textAlign: "center", color: "#8a8e88", fontSize: 13.5 }}>
          You're not a member of any project yet. Your project manager adds you when one starts.
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {projects.map((p) => {
            const h = HEALTH[p.health] ?? HEALTH.ok!;
            return (
              <Link key={p.id} to="/portal/project/$id" params={{ id: p.id }} style={{ textDecoration: "none", color: "inherit", background: "#fff", borderRadius: 3, boxShadow: "inset 0 0 0 1px rgba(0,0,0,.07)", padding: "16px 18px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                  <span style={{ fontFamily: "'Space Mono', monospace", fontSize: 11.5, color: "#8a8e88" }}>{p.id}</span>
                  <span style={{ fontSize: 15.5, fontWeight: 600, color: "#1d241f" }}>{p.name}</span>
                  <span style={{ fontSize: 11, fontWeight: 600, borderRadius: 2, padding: "2px 8px", background: h.bg, color: h.fg }}>{p.status}</span>
                  <span style={{ flex: 1 }} />
                  <Icon name="chevron-right" size={16} color="#bcbfba" />
                </div>
                <div style={{ fontSize: 12.5, color: "#8a8e88", marginTop: 4 }}>{p.phase} · go-live {p.go} · with {p.pm}</div>
                {/* progress vs plan */}
                <div style={{ marginTop: 12, position: "relative", height: 6, borderRadius: 3, background: "#f0efe9" }}>
                  <div style={{ position: "absolute", left: `${p.plannedPct}%`, top: -3, bottom: -3, width: 2, background: "#bcbfba" }} title={`Planned ${p.plannedPct}%`} />
                  <div style={{ width: `${p.pct}%`, height: "100%", borderRadius: 3, background: p.health === "bad" ? "#b3261e" : brand.ink }} />
                </div>
                <div style={{ display: "flex", gap: 14, marginTop: 7, fontSize: 11.5, color: "#8a8e88" }}>
                  <span><b style={{ color: "#1d241f" }}>{p.pct}%</b> complete</span>
                  <span>plan {p.plannedPct}%</span>
                  <span style={{ fontFamily: "'Space Mono', monospace" }}>{p.loggedHrs}/{p.approvedHrs}h</span>
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
